import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/Grid/types";
import SnGrid from "@shared/components/Grid/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
interface Props {
  Menuprops: menuInfo;
}

const EXC000000000029006 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridApiRefH = useRef<any>(null);
  const gridApiRefL = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns1, setColums1] = useState<ColumnConfig[]>([]);
  const [columns2, setColums2] = useState<ColumnConfig[]>([]);
  const [dataSource1, setDataSource1] = useState<any[]>([]);
  const [dataSource2, setDataSource2] = useState<any[]>([]);
  const { userInfo } = global();

    //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "EXC000000000029006";
  const defaultSize = { panel1height: "49.5%", panel2height: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({
          menuInfo: Menuprops,
          etcInfo: {},
        });
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums1(rtn.grid.grid1);
        setColums2(rtn.grid.grid2);
      } catch (error) {}
    };
    fetchform();
  }, []);

    useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const prime = {
        ...searchRef.current.getFormdata(),
        g_cd_firm: userInfo.cd_firm,
        g_cd_cust: userInfo.cd_cust || "",
      };
      const params = {
        id: "exc000000000029006_01",
        params: prime,
      };

      setDataSource1([]);
      setDataSource2([]);

      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      setDataSource2(data[1] || []);

      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        gridApiRefH.current.selectAndFocusRow(0);
        gridApiRefL.current.selectAndFocusRow(0);
      }

      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
    } catch (error: any) {}
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_sales = selectedRow.no_sales;
      gridApiRefL.current.applyFilters({ no_sales: no_sales });
      gridApiRefL.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
        <SnGrid
          seq={1}
          ref={gridApiRefH}
          
          enableAddRow={false}
          columnConfig={columns1} // 컬럼 설정 전달
          rowData={dataSource1}
          onFocusedRowChanged={onFocusedRowChanged}
          enableExternalChart={false}
          isEditable={false}
          rowSelection="single" // 단일 선택 모드
          resizeController={{
          defaultSize: defaultSize,
          onResizeStop: onResizeStop,
          }}
        />
        </SnResizable>
        <SnResizable
          direction={"height"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
        <SnGrid
          seq={2}
          ref={gridApiRefL}
          
          enableAddRow={false}
          columnConfig={columns2} // 컬럼 설정 전달
          rowData={dataSource2}
          enableExternalChart={false}
          isEditable={false}
          rowSelection="multiple" // 단일 선택 모드
          title="매출상세"
          resizeController={{
          defaultSize: defaultSize,
          onResizeStop: onResizeStop,
          }}
        />
        </SnResizable>
      </div>
    </div>
  );
});

export default EXC000000000029006;
